export const isDMM = !!process.env.GATSBY_IS_DMM;
